import React, { useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { AppContext } from '../ContextApi/ContextApi';
import { debounce, orderBy } from "lodash";
import { basePath, formatDate, getCurrentDate, monthData } from '../Constants/constant';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import TooltipComponent from '../Usables/TooltipComponent';
import { IoAdd } from "react-icons/io5";
import RecruiterAssigning from '../Usables/RecruiterAssigning';
import RefreshButton from '../Usables/RefreshButton';
import PageBanner from '../Usables/PageBanner';
import InputField from '../Usables/InputField';
import Dropdown from '../Usables/Dropdown';
import Pagination from '../Usables/Pagination';
import BasicButton from '../Usables/Buttons';
import RecruiterWiseData from '../Usables/RecruiterWiseData';
import { UpDownArrow } from '../Usables/IconButtons';

function AssignRecruiter() {
    const { index } = useParams();
    const { apiHeaderJSON, user} = useContext(AppContext);
    const [allJobs, setAllJobs] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [usersOption, setUsersOption] = useState([{value: "Only Assigned", label: "Assigned"},{value: "Not Assigned", label: "Not Assigned"},]);
    const [recruiterWiseData, setRecruiterWiseData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingFilter, setLoadingFilter] = useState(true);
    const [recruiterModal, setRecruiterModal] = useState(false);
    const [recruiterWiseView, setRecruiterWiseView] = useState(false);
    const [formData, setFormData] = useState({assign_date: "1"});
    const [errors, setErrors] = useState({});
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [paginationRecruiterWiseList, setPaginationRecruiterWiseList] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [ischanged, setIschanged] = useState({ positionListChanged: false, getListChanged: false,});
    const [filterData, setFilterData] = useState({
        isActive: true,
        positionStatus: "Open",
    });
    const [recruiterReportFilter, setRecruiterReportFilter] = useState({
        recruiterStatus: 1,
        isActive: true,
        orderBy: "assigned_at",
        orderDirection: "DESC"
    });

    // filter all posted jobs
    const getList = async () => {
        try {
            const response = await axios.get(`${basePath}/getjobBypage`,{
                params:{
                    limit:pagination?.limit,
                    page:pagination?.page,
                    filter:JSON.stringify(filterData)
                },
                headers:apiHeaderJSON
            });
            // console.log("jobs Filter==>>", response);
            setAllJobs(response?.data?.data);
            setPagination({
                ...pagination,
                totalPages: response?.data?.pages,
                totalRecords: response?.data?.totalRecords
            });
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
            setLoadingFilter(false);
        }
    }

    useEffect(() => {
        if(ischanged?.getListChanged){
            console.log("in getList");
            getList();
            setIschanged({ ...ischanged, getListChanged: false });
        }
    }, [ischanged?.getListChanged]);

    const handleJobSort = (columnName) => {
        if(loadingFilter) return;
        setLoadingFilter("4");
        let key = columnName;
        let direction = "ASC";
        if (filterData?.orderBy === key && filterData?.orderDirection === "ASC") {
            direction = "DESC";
        }
        else if (filterData?.orderBy === key && filterData?.orderDirection === "DESC") {
            direction = "";
            key = ""
        }
        setFilterData({ ...filterData, orderBy: key, orderDirection: direction });
        // else {
        //     setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
        // }
        setIschanged({ ...ischanged, getListChanged: true });
    }

    async function getRecruiterWiseData() {
        try {
            const response = await axios.get(`${basePath}/getassignrecruiterlog`,{
                params:{
                    limit:paginationRecruiterWiseList?.limit,
                    page:paginationRecruiterWiseList?.page,
                    id:localStorage.getItem("userId"),
                    filter:JSON.stringify(recruiterReportFilter)
                },
                headers:apiHeaderJSON
            });
            console.log("getRecruiterWiseData ~ res", response.data);
            setRecruiterWiseData(response.data?.data);
            setPaginationRecruiterWiseList({
                ...paginationRecruiterWiseList,
                totalPages: response?.data?.pages,
                totalRecords: response?.data?.totalRecords
            })
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setLoadingFilter(false);
        }
    }
    useEffect(() => {
        if(ischanged?.getRecruiterWiseDataChanged){
            console.log("in getRecruiterWiseData");
            getRecruiterWiseData();
            setIschanged({ ...ischanged, getRecruiterWiseDataChanged: false });
        }
    }, [ischanged?.getRecruiterWiseDataChanged]);

    const getUserData = async () => {
        const options = {headers:apiHeaderJSON}
        let response = await axios.get(`${basePath}/getRecruiter`, options);
        // console.log(response.data);
        const recruiterList = response?.data?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
        });
        const listFilter = response?.data?.filter((val)=>{
            if(val?.activated === 1) return  val;
        });
        const activeList = listFilter?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
        });
        setAllUsers(recruiterList);
        setUsersOption([{value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"}, ...activeList]);
    }

    const handleSort = (e) => {
        const {id} = e.currentTarget;
        console.log("id", id);
        if (recruiterReportFilter?.orderBy === id) {
            if (recruiterReportFilter?.orderDirection === "DESC") {
                setRecruiterReportFilter({ ...recruiterReportFilter, orderBy: id, orderDirection: 'ASC' });
            }
            else {
                setRecruiterReportFilter({ ...recruiterReportFilter, orderBy: id, orderDirection: 'DESC' });
            }
        }
        else {
            setRecruiterReportFilter({ ...recruiterReportFilter, orderBy: id, orderDirection: 'ASC' });
        }
        setIschanged({ ...ischanged, getRecruiterWiseDataChanged: true });
    }
    const handleRecruiterWiseSelect = (e)=> {
        const { value } = e.target;
        setFilterData({
            ...filterData,
            company: value?.Position?.Company?.company_name,
            position: value?.Position?.position,
            fromDate: "",
            toDate: "",
            candidate: "",
            orderBy: "sourcing_date",
            orderDirection: "DESC"
        });
        handleClose()
        setIschanged({ ...ischanged, getListChanged: true });
    }

    useEffect(() => {
        setLoading("1");
        getList();
        getUserData();
    }, []);

    const handleRecruiter = async (e, position) => {
        const errorList = validateForm();
        console.log("errorList 1", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        try {
            setLoading("3");
            const data = {
                ...formData,
                user_id: localStorage.getItem("userId"),
                
            }
            // console.log("handleRecruiter ~ data", data);
            const options = {headers: apiHeaderJSON,}
            const response =  await axios.post(`${basePath}/assignRecruiter`,data,options)
            if (response.status === 200) {
                console.log(response);
                getList();
                handleClose()
                toast.success(response?.data?.message || "Recruiter Assign Successfully");
            }
            else {
                toast.error(response?.data?.message);
            }
            setLoading(false);
        } catch(e) {
            setLoading(false);
            console.log(e);
            toast.error(e.response?.data?.message || "Internal server issue!!");
        };
    }
    const validateForm = ()=>{
        const errors = {};
        if (!formData?.recruiter_id) {
            errors.recruiter_id = "Recruiter is required!";
            return errors;
        }
        if (!formData?.assign_date) {
            errors.assign_date = "Assign date is required!";
            return errors;
        }
        return errors;
    }
    const handleDeleteRecruiter = async (val) => {
        Swal.fire({
        title: 'Are you sure?',
        text: `Are you sure to remove "${val?.User?.name}" from "${val?.position}" position?`,
        icon: 'warning',
        input: 'textarea',
        inputPlaceholder: 'Enter remark...',
        inputAttributes: {'aria-label': 'Enter Remark',},
        showCancelButton: true,
        confirmButtonText: 'Yes, Remove!',
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30',
        cancelButtonColor: '#F44336',
        allowOutsideClick: false,
        }).then(async(result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Removing recruiter...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                try {
                    const data = {
                        recruiter_id: val?.recruiter_id,
                        position_id: val?.id,
                        user_id: localStorage.getItem("userId"),
                        remarks: result.value || ""
                    }
                    const options = {
                        headers: apiHeaderJSON,
                        data
                    }
                    const response = await axios.delete(`${basePath}/deleteassingrecruiter`, options);
                    if (response.status === 200) {
                        // console.log(response);
                        toast.success(response?.data?.message || "Recruiter Removed Successfully");
                        getList();
                    }
                    else {
                        toast.error(response?.data?.message || "Unable to Remove!!");
                    }
                    Swal.close();
                } catch(e) {
                    console.log(e);
                    Swal.close();
                    toast.error(e.response?.data?.message || "Internal Server Issue!!");
                }
            }
        });
    }

    const handleExport = async () => {
        try {
            setLoadingFilter("3");
            const response = await axios.get(`${basePath}/exportAssignRecruiter?download=yes&filter=${JSON.stringify(filterData)}`, {
                responseType: 'blob', // Ensure response is treated as a blob
                headers:apiHeaderJSON
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exported_jobs.xlsx');
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            setLoadingFilter(false);
        } catch (error) {
            console.error('Error exporting jobs:', error);
            setLoadingFilter(false);
        }
    };
    const handleRecruiterWiseExport = async () => {
        try {
            const response = await axios.get(`${basePath}/getassignrecruiterlog?download=yes&id=${localStorage.getItem("userId")}&filter=${JSON.stringify(recruiterReportFilter)}`, {
                responseType: 'blob', // Ensure response is treated as a blob
                headers:apiHeaderJSON
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exported_jobs.xlsx');
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting jobs:', error);
        }
    };
    const handleFilter = ()=> {
        setLoadingFilter("1");
        getList();
    }
    const handleRecruiterWiseFilter = ()=> {
        setLoadingFilter("4");
        getRecruiterWiseData();
    }
    const handleClear = ()=> {
        setLoadingFilter("2")
        setFilterData({fromDate: "", toDate: "",
            company: "", position: "",
            recruiterId: "", isActive: true,
            positionStatus: "Open",
        });
        const all = allUsers?.filter((val)=>{
            if(val?.activated === 1) return val;
        });
        setUsersOption([{value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"}, ...all]);
        setIschanged({...ischanged, getListChanged: true});
    }
    const handleRecruiterWiseClear = ()=> {
        setLoadingFilter("5")
        setRecruiterReportFilter({fromDate: "", toDate: "",
            company: "", position: "",
            recruiter: "", isActive: true,
            positionStatus: "",
            orderBy: "assigned_at",
            orderDirection: "DESC"
        });
        const all = allUsers?.filter((val)=>{
            if(val?.activated === 1) return val;
        });
        setUsersOption([{value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"}, ...all]);
        setIschanged({...ischanged, getRecruiterWiseDataChanged: true});
    }
    const handleRecruiterReportModal = ()=> {
        setRecruiterReportFilter({fromDate: "", toDate: "",
            company: "", position: "", orderBy: "assigned_at", recruiter: "",
            recruiterStatus: 1, isActive: true, orderDirection: "DESC",
            status: "",
        });
        setRecruiterWiseView(true);
        setIschanged({...ischanged, getRecruiterWiseDataChanged: true});
    }

    const handleChangeRecruiterStatus = (e)=> {
        if(!e.target.value) return;
        // console.log("e.target.value",e.target.value);
        const num = parseInt(e.target.value);
        const all = allUsers?.filter((val,idx)=>{
            if(val?.activated === num) return val;
        });
        setUsersOption([{value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"}, ...all]);
    }

    const handleAssign = (val)=> {
        const all = allUsers?.filter((val)=>{if(val?.activated === 1) return val;});
        setUsersOption([{value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"}, ...all]);
        setRecruiterModal(true);
        setFormData({assign_date: "1", position_id: val?.id,});
    }
    const handleAssignDate = useCallback((e)=> {
        const {id} = e.target;
        setFormData({...formData, assign_date: id });
    },[formData]);

    const handleChange = useCallback((e)=> {
        const {value, name} = e.target;
        setFormData({...formData, [name]: value });
        setErrors({...errors, [name]: "" });
    },[formData, errors]);

    const handleClose = ()=> {
        setRecruiterModal(false);
        setRecruiterReportFilter({fromDate: "", toDate: "",
            company: "", position: "", orderBy: "assigned_at", recruiter: "",
            recruiterStatus: 1, isActive: true, orderDirection: "DESC",
            status: "",});
        if (recruiterWiseView){
            const all = allUsers?.filter((val)=>{if(val?.activated === 1) return val;});
            setUsersOption([
                {value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"}, ...all]);
        }
        setRecruiterWiseView(false)
        setPaginationRecruiterWiseList({page: 1, totalRecords: "", totalPages: "", limit: 10,})
        setFormData({assign_date: "1"});
        setErrors({});
    }   
    const handleRefresh = ()=> {
        setLoading("1");
        getList();
    }   
    const handleRecruiterWiseRefresh = ()=> {
        setLoading("2");
        getRecruiterWiseData();
    }   
    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        setFilterData({ ...filterData, [name]: value, });               
    },[filterData]);
    const handleChangeRecruiterWiseFilter = useCallback((event)=> {
        const {name, value} = event?.target;
         console.log("name, value",name, value);
        setRecruiterReportFilter({ ...recruiterReportFilter, [name]: value, });               
    },[recruiterReportFilter]);

    const handleCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        // console.log(checked);
        const num = !checked ? 2 : 1;
        // console.log("allUsers",allUsers);
        const all = allUsers?.filter((val)=>{if(val?.activated === num) return val;});
        setFilterData({ ...filterData, isActive: checked }); 
        setUsersOption([
            {value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"},
            ...all]);
    },[allUsers, filterData]);

    const handleRecruiterWiseCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        // console.log(checked);
        const num = !checked ? 2 : 1;
        // console.log("allUsers",allUsers);
        const all = allUsers?.filter((val)=>{if(val?.activated === num) return val;});
        setRecruiterReportFilter({ ...recruiterReportFilter, isActive: checked }); 
        setUsersOption([
            {value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"},
            ...all]);
    },[allUsers, recruiterReportFilter]);

    const bgColors = [
    'bg-blue-900', 'bg-amber-900',
    'bg-yellow-500', 'bg-purple-500', 'bg-pink-500',
    'bg-indigo-500', 'bg-rose-500', 'bg-teal-500'
    ];
    const jobStatusOptions = [
        { value: "All", label:"All"},
        { value: "Open", label:"Open"},
        { value: "Close", label:"Close"},
    ];

    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getListChanged: true});
    }
    const handlePrev = ()=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }
    const handleNext = ()=> {
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }
    const handleRecruiterWiseLimit = (e)=> {
        setPaginationRecruiterWiseList({...paginationRecruiterWiseList, limit: e.target.value});
        setIschanged({...ischanged, getRecruiterWiseDataChanged: true});
    }
    const handleRecruiterWisePrev = ()=> {
        if (pagination?.page > 1) {
            setPaginationRecruiterWiseList({...paginationRecruiterWiseList, page: pagination?.page - 1});
            setIschanged({...ischanged, getRecruiterWiseDataChanged: true});
        }
    }
    const handleRecruiterWiseNext = ()=> {
        if (pagination?.totalPages > pagination?.page) {
            setPaginationRecruiterWiseList({...paginationRecruiterWiseList, page: pagination?.page + 1});
            setIschanged({...ischanged, getRecruiterWiseDataChanged: true});
        }
    }

    return (
        <section className='lightBabyGreen baseHeightWidth customScroll mb-5'>
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            <div>
                {/* PageBanner => used to show page banner info */}
                <PageBanner pageName='Assign Recruiter' pageTitle='Ready to start your day' src='/img/registration.png' alt="screened candidate" />
                {recruiterModal && (
                    <RecruiterAssigning 
                    formData={formData}
                    options={usersOption}
                    loading={loading === "2"}
                    errors={errors}
                    onAssignDate={handleAssignDate}
                    onClose={handleClose}
                    onChange={handleChange}
                    onSubmit={handleRecruiter}
                    />
                )}
                {recruiterWiseView &&
                    <RecruiterWiseData
                    rows={recruiterWiseData}
                    filterData={recruiterReportFilter}
                    pagination={paginationRecruiterWiseList}
                    loading={loading === "2"}
                    loadingFilter={loadingFilter}
                    usersOption={usersOption}
                    onRefresh={handleRecruiterWiseRefresh}
                    onClose={handleClose}
                    onFilterChange={handleChangeRecruiterWiseFilter}
                    onFilter={handleRecruiterWiseFilter}
                    onClear={handleRecruiterWiseClear}
                    onExport={handleRecruiterWiseExport}
                    onSort={handleSort}
                    onRecruiterWiseDataSelect={handleRecruiterWiseSelect}
                    onCheck={handleRecruiterWiseCheck}
                    onLimit={handleRecruiterWiseLimit}
                    onPrev={handleRecruiterWisePrev}
                    onNext={handleRecruiterWiseNext}
                    />
                }
                <div className=' grid lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mt-5 rounded-xl'>
                    {/* <h1>Date Filter</h1> */}
                    <InputField  id="fromDate" name="fromDate" type="date" label="From:"
                    disabled={loading === '1'}
                    value={filterData?.fromDate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="toDate" name="toDate" type="date" label="To:"
                    disabled={loading === '1'}
                    value={filterData?.toDate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="company" name="company" type="text" label="Company:"
                    placeholder="Enter Company"
                    disabled={loading === '1'}
                    value={filterData?.company}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="position" name="position" type="text" label="Position:"
                    placeholder="Enter Position"
                    disabled={loading === '1'}
                    value={filterData?.position}
                    onChange={handleChangeFilter}
                    />
                    {localStorage.getItem("role") === "Recruiter" ? null :
                    <Dropdown id="recruiterId" name="recruiterId" label="Recruiter:"
                        onChange={handleChangeFilter}
                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                        placeholder={`Select Recruiter`}
                        value={filterData?.recruiterId}
                        options={usersOption}
                        search={true} // to enable search input
                        checkBox={true} // to enable checkbox
                        checkValue={filterData?.isActive} // to make checkbox check and uncheck
                        onCheck={handleCheck} // to make changes in list of options onChange  
                    />}
                    <Dropdown id="positionStatus" name="positionStatus"
                        onChange={handleChangeFilter}
                        onCancel={handleChangeFilter}
                        label="Position Status:"
                        className={`rounded border bg-white border-gray-300 w-full flex-1 text-[0.8rem]`}
                        placeholder={`All`}
                        value={filterData?.positionStatus}
                        options={jobStatusOptions}
                    />
                    <div className="flex gap-3 col-span-1">
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                            <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.candidate && !filterData?.company && !filterData?.position && !filterData?.recruiterId && !filterData?.positionStatus)} 
                            loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                            <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.candidate && !filterData?.company && !filterData?.position && !filterData?.recruiterId && !filterData?.positionStatus)} 
                            loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                            <BasicButton onClick={handleExport} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                            disabled={loading || loadingFilter } 
                            loading={loadingFilter === "3"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Recruiter Details</label>
                            <BasicButton onClick={handleRecruiterReportModal} buttonName='Recruiter Details' className="bg-purple-700 text-nowrap" shadow={true}
                            disabled={loading} 
                            rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-purple-900" />
                        </div>
                    </div>
                </div>

                {!loading ?
                    Array.isArray(allJobs) && allJobs?.length >= 1 ?
                        <section className='tableWrapper'>
                            <div className='tableBody'>
                                <table className='w-full table-fixed border-collapse'>
                                    <thead className='tableHead'>
                                        <tr className='bg-gray-200 text-left'>
                                            {/* <th className=' whitespace-nowrap text-center w-[10%]'>Posted Date</th> */}
                                            <th className='whitespace-nowrap text-center w-[14%]'>
                                                <div onClick={() => handleJobSort("upload_date")} className='flex item-center gap-2 pr-2 justify-center w-full cursor-pointer'>
                                                    Posted Date
                                                    {filterData?.orderBy === "upload_date" && filterData?.orderDirection === "ASC" ?
                                                        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                        filterData?.orderBy === "upload_date" && filterData?.orderDirection === "DESC" ?
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                                </div>
                                            </th>
                                            {/* <th >Position</th> */}
                                            <th className=' '>
                                                <div onClick={() => handleJobSort("position")} className='flex item-center gap-2 pr-2 justify-start cursor-pointer'>
                                                    Position
                                                    {filterData?.orderBy === "position" && filterData?.orderDirection === "ASC" ?
                                                        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                        filterData?.orderBy === "position" && filterData?.orderDirection === "DESC" ?
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                                </div>
                                            </th>
                                            <th className='w-[16%]'>Location</th>
                                            {/* <th className='w-[15%]'>CTC</th> */}
                                            <th className='w-[15%]'>
                                                <div onClick={() => handleJobSort("max_ctc")} className='flex item-center gap-2 pr-2 justify-start w-full cursor-pointer'>
                                                    CTC
                                                    {filterData?.orderBy === "max_ctc" && filterData?.orderDirection === "ASC" ?
                                                        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                        filterData?.orderBy === "max_ctc" && filterData?.orderDirection === "DESC" ?
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                                </div>
                                            </th>
                                            <th className=' whitespace-nowrap w-[16%]'>Gender Preference</th>
                                            <th className=' whitespace-nowrap text-center w-[16%]'>
                                                <div onClick={() => handleJobSort("recruiter")} className='flex item-center gap-2 pr-2 justify-start w-full cursor-pointer'>
                                                    Recruiter
                                                    {filterData?.orderBy === "recruiter" && filterData?.orderDirection === "ASC" ?
                                                        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                        filterData?.orderBy === "recruiter" && filterData?.orderDirection === "DESC" ?
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                                </div>
                                            </th>
                                            {/* {user[index]?.edit_access && <th className=' whitespace-nowrap'>Assign Recruiter</th>} */}
                                        </tr>
                                    </thead>
                                    <tbody className='tableBody '>
                                        {
                                            Array.isArray(allJobs) && allJobs?.map((val, idx) => {

                                                return (
                                                    <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm text-left'>
                                                        <td className=' whitespace-nowrap text-center'>{val?.upload_date?.split("T")[0]?.split("-")[2]} {monthData[parseInt(val?.upload_date?.split("T")[0]?.split("-")[1])]} {val?.upload_date?.split("T")[0]?.split("-")[0]}</td>
                                                        <td>
                                                            <span className='line-clamp-1 text-ellipsis' >{val?.position}</span>
                                                            <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.Company.company_name}</span>
                                                        </td>
                                                        <td className='whitespace-nowrap w-full line-clamp-1 text-ellipsis'>{val?.location}</td>
                                                        <td>
                                                            <div className=' whitespace-nowrap w-full line-clamp-1 text-ellipsis'>
                                                                <span className=' text-green-500'>{val?.currency_code}</span> {val?.max_ctc} LPA
                                                            </div>
                                                        </td>
                                                        <td>{val?.gender_pref}</td>
                                                        <td>
                                                            {
                                                                val?.assignRecuiters?.length >= 1 ?
                                                                    <div>
                                                                        <div className="flex -space-x-3 overflow-hidden">
                                                                            {val?.assignRecuiters?.length > 0 &&
                                                                                val?.assignRecuiters.slice(0, 6).map((item, index) => {
                                                                                    const colorClass = bgColors[index % bgColors.length];
                                                                                    return (
                                                                                    <TooltipComponent className={`${val?.assignRecuiters.length > 1 ? "" : `w-full ${user[index]?.edit_access && "max-w-[8.5dvw]"}`}`} name={item?.User?.name} key={item?.recruiter_id}>
                                                                                        <h1
                                                                                        onClick={(e) => {
                                                                                            if (user[index]?.edit_access) {
                                                                                            // setRecruiterName(item?.User?.name);
                                                                                            // setPositionId(val?.id);
                                                                                            // setRecruiterId(item?.recruiter_id);
                                                                                            // setConfirmation(`${idx}`);
                                                                                            handleDeleteRecruiter({...val, ...item})
                                                                                            }
                                                                                        }}
                                                                                        className={`border border-white rounded-full ${val?.assignRecuiters.length > 1 ? "relative w-9 h-9" : "px-2 py-2 whitespace-nowrap w-full line-clamp-1 text-ellipsis"}  text-center text-white ${colorClass} ${
                                                                                            user[index]?.edit_access && "cursor-pointer hoverRed"
                                                                                        }`}
                                                                                        >
                                                                                            {val?.assignRecuiters.length > 1
                                                                                            ? <span className=' absolute top-[22%] left-[20%]'>{item?.User?.name?.split("")[0]}{item?.User?.name?.split(" ")[1]?.split("")[0] || ""}</span>
                                                                                            : item?.User?.name}
                                                                                        </h1>
                                                                                    </TooltipComponent>
                                                                                    );
                                                                                })}
                                                                                {val?.assignRecuiters?.length < 6 && user[index]?.edit_access && (
                                                                                <TooltipComponent name="Assign Recruiter">
                                                                                    <div onClick={()=> handleAssign(val)} className='relative w-9 h-9 rounded-full bg-gray-300 text-center border border-white cursor-pointer
                                                                                    hover:bg-gray-400 transition-all duration-300 ease-in-out'>
                                                                                        <span className=' absolute top-[15%] left-[15%]'>
                                                                                            <IoAdd className=' text-2xl font-bold' />
                                                                                        </span>
                                                                                    </div>
                                                                                </TooltipComponent>
                                                                                )}
                                                                        </div>
                                                                    </div> 
                                                                    :
                                                                    user[index]?.edit_access ?
                                                                    (<h1 onClick={()=> handleAssign(val)} className='flex justify-center items-center p-2 cursor-pointer rounded-lg bg-gray-300 w-full whitespace-nowrap 
                                                                    hover:bg-gray-400 transition-all duration-300 ease-in-out'>
                                                                        <TooltipComponent className="w-full flex justify-center items-center" name="Assign Recruiter">
                                                                            <IoAdd className=' text-2xl font-bold' /> Assign
                                                                        </TooltipComponent>
                                                                    </h1>) : 
                                                                    (<div className='text-center p-2 rounded-full yellowBox w-full whitespace-nowrap '>
                                                                        Not Assigned
                                                                    </div>)
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                            limit={pagination?.pagelimit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                            disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                            />
                        </section> :
                        <div className='navAnimation flex flex-col justify-center items-center bg-white mt-5 py-5 mb-10 rounded-3xl '>
                            <img className=' w-[24%]' src="/img/addReports.png" alt="" />
                            <h1 className=' text-2xl font-bold'>Oops!! "<span className=' text-blue-950'>No Reports Found</span>"</h1>
                        </div> :
                    <div className=' loaderBox mb-5 bg-white mt-5 rounded-3xl '>
                        <img className=' m-auto w-1/4' src="/img/loader2.gif" alt="loading..." />
                    </div>
                }
            </div>
        </section>
    );
}

export default AssignRecruiter;